/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/AddedBy/Content"
  
}) {
let connectionUserVaxiomPersonValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
path: 'user.vaxiom_person',
format: fromFormat.patientName,
})
let connectionCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'connection',
path: 'created_at',
format: fromHelpers.formatDate,
})
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="connection.user.vaxiom_person"
 format="/Data/format.js patientName"
 text={connectionUserVaxiomPersonValueData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral500}
 data="connection.created_at"
 format="helpers.js formatDate"
 text={connectionCreatedAtValueData}
/>
</div>
{children}
</React.Fragment>)
}